const alertSeverities = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success',
}

export default alertSeverities;